import { Wrapper } from 'components'

import './account-footer.scss'

export default Wrapper( 'account-footer' )